module.exports = __webpack_public_path__ + "images/background-hero-15a229648faefed87a4be28588af3961.png";